import {USER_ACTIONS} from "./types";
import {GET, POST, async, DELETE, PUT} from 'ith-fetch';
import {addError} from "./errorActions";
import {shouldUpdate, shouldUpdateExtend, updateFetch} from "ith-redux-helpers";
import {addProcessing, removeProcessing} from "./processingActions";
import {
	PROC_CREATE_ACCESS,
	PROC_DELETE_ACCESS, PROC_LOAD_ACCESS,
	PROC_LOGIN,
	PROC_LOGOUT,
	PROC_PASSWORD_ACCESS,
	PROC_UPDATE_ACCESS, UPDATE_USER_LIST
} from "./index";
import {showSnackbar} from "./snachbarActions";
import {push} from "react-router-redux";

const _set = (user = null) => ({type: USER_ACTIONS.SET, user});
const _setList = (list = []) => ({type: USER_ACTIONS.SET_LIST, list});
const _addAdmin = (admin) => ({type: USER_ACTIONS.ADD_ADMIN, admin});
const _removeAdmin = admin => ({type: USER_ACTIONS.REMOVE_ADMIN, admin});
const _updateProfile = user => ({type: USER_ACTIONS.UPDATE_PROFILE, user});

const __STORAGE__ = 'admin-store-user';

const _setStorage = user => async().then(() => window.localStorage.setItem(__STORAGE__, JSON.stringify(updateFetch(user))));
const _getStorage = () => JSON.parse(window.localStorage.getItem(__STORAGE__) || null );
export const clearUserStorage = () => async().then(() => window.localStorage.removeItem(__STORAGE__));

export const isOnline = (onSuccess) =>
	async (dispatch, getState) => {
		try {
			const storageUser = getState().user.data || _getStorage();
			if ( !shouldUpdate(storageUser) ) {
				!getState().user.data && dispatch(_set(storageUser));
				onSuccess && onSuccess(storageUser);
				return;
			}
			// dispatch(addLoader());
			const user = await GET('/online');
			if ( user.acknowledged) {
				dispatch(_set(user.admin));
				_setStorage(user.admin);
				onSuccess && onSuccess(user.admin);
			} else {
				throw new Error('user has not been ack\'d');
			}
		} catch (e) {
			console.error('isOnline:', e);
			dispatch(_set());
		} finally {
			// dispatch(removeLoader());
		}
	};

export const loginAdmin = (data, onSuccess) =>
	async (dispatch) => {
		try {
			// dispatch(addLoader());
			dispatch(addProcessing(PROC_LOGIN));
			const user = await POST('/login', data);
			dispatch(_set(user));
			_setStorage(user);
			onSuccess && onSuccess(user);
		} catch (e) {
			console.error('failed to login:', e);
			dispatch(addError(e.message));
		} finally {
			// dispatch(removeLoader());
			dispatch(removeProcessing(PROC_LOGIN));
		}
	};
export const logoutAdmin = (onSuccess = undefined) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_LOGOUT));
			// dispatch(addLoader());
			await DELETE('/login');
			dispatch(_set());
			clearUserStorage();
			onSuccess && onSuccess();
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			// dispatch(removeLoader());
			dispatch(removeProcessing(PROC_LOGOUT));
			dispatch(push('/'));
		}
		
	};
export const loadAdminList = (onSuccess) =>
	async (dispatch, getState) => {
		try {
			if ( !shouldUpdateExtend(getState().user, UPDATE_USER_LIST)) {
				console.debug('admin list is cached');
				return;
			}
			dispatch(addProcessing(PROC_LOAD_ACCESS));
			const list = await GET('/');
			console.log('list', list);
			dispatch(_setList(list));
			onSuccess && onSuccess(list);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_LOAD_ACCESS));
		}
	};
export const createAdmin = (data, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_CREATE_ACCESS));
			const result = await PUT('/', data);
			dispatch(_addAdmin(result.admin));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_CREATE_ACCESS));
		}
		
	};
export const removeAdmin = (admin_id, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_DELETE_ACCESS, admin_id));
			const result = await DELETE(`/id/${admin_id}`);
			dispatch(_removeAdmin(result.admin));
			dispatch(showSnackbar('snackbar.access.removed'));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_DELETE_ACCESS, admin_id));
		}
	};
export const updateProfile = (data, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_UPDATE_ACCESS));
			const result = await POST('/', data);
			dispatch(_updateProfile(result.user));
			onSuccess && onSuccess(result);
			dispatch(showSnackbar('snackbar.profile.changed'));
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_UPDATE_ACCESS));
		}
	};
export const updateProfilePassword = (data, onSuccess) =>
    async dispatch => {
		try {
			dispatch(addProcessing(PROC_PASSWORD_ACCESS));
			const {acknowledged} = await POST('/password', data);
			dispatch(showSnackbar('snackbar.profile.password_changed'));
			onSuccess && onSuccess(acknowledged);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_PASSWORD_ACCESS));
	}
};

export const callDumps = () => GET('/dumps');
export const restoreDump = (id) => POST(`/dump/restore/${id}`);
export const deleteDump = (id) => DELETE(`/dump/${id}`);
export const translateDump = () => POST('/dump/translate');


// WEBPACK FOOTER //
// ./src/actions/userActions.js